import { navigate, routes, useLocation } from '@cedarjs/router'

import { useAuth } from 'src/auth'
import { useResetAuthState } from 'src/hooks/use-reset-auth-state'

import { useIsInIFrame } from './use-is-in-iframe'

export const useRedirectToLoginIfUnauthenticated = (args?: { enabled?: boolean }) => {
  const { enabled = true } = args ?? {}
  const { isAuthenticated, loading: isLoadingAuth } = useAuth()
  const { pathname, search } = useLocation()
  const resetAuthState = useResetAuthState()
  const isInIFrame = useIsInIFrame()
  if (!isAuthenticated && !isLoadingAuth && enabled && !isInIFrame) {
    void (async () => {
      await resetAuthState()
      // Preserve query parameters so email click tracking survives the Clerk flow.
      const redirectUrl = pathname ? `${pathname}${search ?? ''}` : undefined
      navigate(routes.login(redirectUrl ? { redirectTo: redirectUrl } : {}))
    })()
  }
}
